import { Label } from '@/types';

export const labelOrDefault = (name: Opt<Label>, currentLang: string) => {
  return name ? name[currentLang] ?? name[Object.keys(name)[0]] : '';
};
